module.exports = __webpack_public_path__ + "img/5-1.ae02cd9e.svg";